import * as React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import ListSubheader from '@mui/material/ListSubheader';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import IconButton from '@mui/material/IconButton';
import { motion, AnimatePresence } from "framer-motion";
import styled from 'styled-components'
import { ReactComponent as SpotIcon } from '../assets/spot.svg';
import { ReactComponent as AppleIcon } from '../assets/apple_logo.svg';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';


export default function TitlebarImageList({images}) {
  const onPlayClick = (songId, platform) => (event) => {
    console.log(event, songId, platform)
    let url;
    if (platform === 'spotify') {
      url = `https://open.spotify.com/track/${songId}`
    } else {
      url = `https://music.apple.com/us/song/${songId}`
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  const theme = useTheme();
  const matchDownMd = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <ImageList cols={matchDownMd ? 1 : 3 }>
      { !!images.length &&
        <ImageListItem cols={matchDownMd ? 1 : 3 }>
          <ListSubheader style={{zIndex: "auto"}} component="div">Your Generated Art:</ListSubheader>
        </ImageListItem>
      }
      {images.map((item) => (
        <AnimatePresence key={item.url}>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ delay: 0.6, duration: 0.5 }}
          >
            <ImageListItem >
              <img
                src={`${item.url}?w=256&fit=crop&auto=format`}
                srcSet={`${item.url}?w=256&fit=crop&auto=format&dpr=2 2x`}
                loading="lazy"
              />
              <ImageListItemBar
                title={item.name + ' - ' + item.artist}
                subtitle={item.prompt}
                actionIcon={
                  <IconButton onClick={onPlayClick(item.song_id, item.platform)} sx={{ color: 'rgba(255, 255, 255, 0.54)' }}>
                    {item.platform === 'spotify'
                      ? <SpotIcon style={{minWidth:"20px", fill: "white"}}></SpotIcon>
                      : <AppleIcon style={{maxWidth:"40px", fill: "white"}}></AppleIcon>
                    }
                  </IconButton>
                }
              />
            </ImageListItem>
          </motion.div>
        </AnimatePresence>
      ))}
    </ImageList>
  );
}
